export default "__VITE_ASSET__D7VU2hSZ__"